<template>
  <div id="app">
    <Header @modal-option="selectedView" />
    <MyNav :displayModal="modalOption" @modal-option="selectedView" />
    <mobile-nav @modal-option="selectedView" />
    <SideNav />
    <slide-out />
    <section id="mainArea">
      <div class="container-fluid">
        <div class="row">
          <div
            class="col s12"
            :class="[
              window.width >= 991 ? 'l9' : 'l8',
              window.width >= 600 && window.width <= 900 ? 'm8' : 'm8'
            ]"
          >
            <div class="row mobileMenu">
              <div class="col s6">
                <router-link to="/" class="waves-effect">
                  <button class="waves-effect waves-light btn-small">
                    <i class="fa fa-lightbulb-o" style="color: #fff"></i>
                    Electricity
                  </button>
                </router-link>
              </div>
              <div class="col s6">
                <router-link to="/airtime" class="waves-effect">
                  <button class="waves-effect waves-light btn-small">
                    <i class="fa fa-mobile" style="color: #fff"></i>
                    Airtime
                  </button>
                </router-link>
              </div>
            </div>
            <div class="row mobileMenu">
              <div class="col s6">
                <router-link to="/data" class="waves-effect">
                  <button class="waves-effect waves-light btn-small">
                    <i class="fa fa-globe" style="color: #fff"></i>
                    Data
                  </button>
                </router-link>
              </div>
              <div class="col s6">
                <router-link to="/tv" class="waves-effect">
                  <button class="waves-effect waves-light btn-small">
                    <i class="fa fa-tv" style="color: #fff"></i>
                    TV
                  </button>
                </router-link>
              </div>
            </div>
            <router-view @modal-option="selectedView" />
          </div>
          <div
            class="col s12"
            :class="[
              window.width >= 991 ? 'l3' : 'l4',
              window.width >= 600 && window.width <= 900 ? 'm4' : 'm4'
            ]"
          >
            <!-- Company Advertisements slides here as many as possible -->
            <ads-slider @modal-option="selectedView" />
          </div>
        </div>
      </div>
    </section>
    <footer-section />
  </div>
</template>
<script>
import Header from './components/partials/Header.vue'
import MyNav from './components/partials/MyNav.vue'
import MobileNav from './components/partials/MobileNav.vue'
import SideNav from './components/partials/SideNav.vue'
import SlideOut from './components/partials/SlideOut.vue'
import AdsSlider from './components/partials/AdsSlider.vue'
import FooterSection from './components/partials/FooterInfo.vue'

export default {
  /* eslint-disable */
  name: 'app',
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'iRecharge � ',
    meta: [
      { charset: 'utf-8' },
      { name: 'google-site-verification', content: 'eZGf0PkbzrSeaqQnyW1T8me2dghWtsjuVToa_gYxF5M' },
      { name: 'ROBOTS', content: 'INDEX, FOLLOW' },
      { name: 'msvalidate.01', content: '64A7464A2035AB21A05441FB5BA9E56A' },
      { name: 'description', content: 'iRecharge is a distributed vending platform for making Online Bills Payment such as Data Recharge, Airtime Topup, Prepaid Meter Recharge, Online Electricity Bills Payments and Cable TV Subscription at your convenience.' },
      { name: 'keywords', content: 'iRecharge, iRecharge Online, iRecarge, i-recharge, iRecharge Biz, iRecharge App, Prepaid Meter, Recharge Online, Buy Electricity Online, Make Payments Online, Prepaid Electricity, Postpaid Electricity, Mtn, Glo, Airtel, Aedc, Aedc Recharge, Recharge Phcn Meter, Kedco, Nepa Meter Recharge, Kaduna Electricity Payment Onine, Pay Bills, Purchase Electricity, Buy Meter Token, Buy Airtime, Buy Data, Buy Power, Buypower Aedc, Buy Electricity Token, Gotv, Dstv Subscription, Online Startimes Subscription, Electricity Bill Payment Online, Pay Nepa Bill, Electricity Payment Online, Best Electricity Bills Payment Nigeria, How To Pay Electricity Online, Buy Power Ng , Buypower, Online Purchase For  Aedc, Nepa Meter Recharge. Online Electricity Pin Recharge, GOTV Payment, GOTV Payment Online, GOTV Payment Nigeria, GOTV Payment Outlets, GOTV Payment With Atm Card, GOTV Payment Methods, GOVT Subscription Renewal, Buy Electricity Online, Recharge Electricity Nigeria, Electricity Tokens Online, buyower, buy electricity, gtbank online banking, electricity bills online, electricity bill online payment, gtbank customer service number, paypower phone number, ng electric, gtbank internet banking login, gtnank, internet banking gtb Nigeria, ibuypower discount code 2019, buy here pay here nepa, www.gtbank.com login, ibuypower office locations, buypower card application status, buypower customer service number, wow customers service, gtbank online account opening, electricals bill, paylightbill, paypower customer service, buy light online, online prepaid electricity, adec tech support, ibuypower customer support, gtbank com, buypower credit card login, electricity units, recharge.com customer service phone number, internet banking for gtbank, light recharge, ibuypower 2019, uba online banking, ibuypower tech support number, ikeja electric, buy electricity online, gtbank internet banking, wow 24 hour support number, uba bank mobile, ibuypower support, wow customer service number, gtbank internet banking nigeria, electricity bill app, buy power, buypowercard login, paga login, buy power login, buypower in abuja, buy power nigeria,' },
      { name: 'keywords', content: 'irecharge online, jos a bank online, gtbank, buy electricity, buyelectricity, buy power login, buypower login, buypower com, prepaid meter nigeria, ng power, power buy card online, buy electricity online, buy online electricity, abuja electricity distribution company, pay nepa bill online, pay nepa bills online, paying nepa bills online, online electricity purchase, buy prepaid online, can u top up electric online, order electricity online, how to buy power, buypower abuja, payelectricitybills, phcn website, how to pay prepaid online, ikeja electric payment, buypower in abuja, aedc buy power, buy nepa token online, buypower merchant, buypower jos, buypower in nigeria, buypower kaduna electric, buy light in abuja, buy power online lagos, buypower aedc, how to recharge aedc meter, phcn headquarters abuja, light up nigeria, no electricity in lagos, kadco electric, opay head office address in lagos, how to recharge ibedc prepaid meter online, kaedco, buy cash power electricity, how to recharge ikeja electric prepaid meter, n power nigeria website, power recharge app, how to know my prepaid meter number, how to buy electricity, phcn prepaid meter, can\'t buy electricity, electricity bill payment online app, buy prepaid electricity online with credit card, ikeja electric prepaid customer service, ikeja electric payment partners, jed download, kaduna electric meter, how to load prepaid meter online, free electricity token number, electricity bill payment, irecharge online, irecharge vendor, irecharge, irecharge website, quickteller, quikteller, interswitch, ntel, gotv subscription, dstv pay, dstv where to pay, subscribe for gotv, pay dstv, paydstv,subscribe to dstv, quick teller, payment of gotv, go tv payment, gotv payment, pay for go tv, payment of go tv, pay gotv, go tv payments, gotv pay, paying for gotv, dstv payment online, dstv subscription, subscribe for dstv, subscribe dstv, quickteller app, quickteller dstv, dstv quickteller, pay dstv subscription, quickteller gotv, quickteller nigeria, dstv online subscription, gotv quickteller, pay bills online in nigeria, quickteller ikeja electric, quickteller services, quickteller send money, quickteller phcn prepaid payment, quickteller ekedc, gotv quickteller payment, pay prepaid nepa bill online, startimes nigeria online payment, kaduna electric prepaid online payment, how to pay startimes, quickteller phcn prepaid, dstv subscription quickteller, quickteller eedc payment, how to pay nepa bill online, eko electricity distribution company quickteller, eko electricity distribution company, quickteller gotv payment, quickteller fund transfer, www quickteller com dstv, how to make gotv payment on quickteller, pay for dstv online, quickteller bill payment, how to register quickteller, www quickteller com ecash web, quickteller online instant deposit, quickteller for gotv, online dstv subscription, gotv payments, opay, download opay application, opay app, opay nigeria, wow bill pay number, i need some free money, opay login, opay pos machine, how do i make money from my phone, put free money in your bank account, opay pos in nigeria, opera pay nigeria, how to transfer money online to nigeria, online business in nigeria that pays daily, electricity bill payment, online electricity top up, buy electricity token, online electricity bill, how to apply for prepaid meter online in lagos, ibuypower discount code, ibuypower number, recharge light online, ikeja electric website, how much is a unit of electricity in nigeria, buy power card number, ibuypower support, adec customer service, buypower credit card login, buypowercard com, kedco nigeria, how to borrow light from prepaid meter, prepaid electricity free nights, how to top up electric meter, online eb bill, ibuypower.com support, nigeria electricity company, buypower card application status, buypower, prepay power head office, how to buy electricity on your phone, power buy call center, can i top up electric online, adec inc, cost of prepaid meter in abuja, how to buy a wow token, buy wow token online, prepaid meter nairaland, how to apply for aedc prepaid meter, online shopping in abuja nigeria, how to load tokens on meter, ikeja electric prepaid meter token, electricity bill payment apps, how does prepaid meter work in nigeria, phcn customer care, download ikeja electric app, www gtbank internet banking login, aedc online, download gtbank internet banking, neppa, buypower customer service number, adec phone number, how to buy data from gtbank, how to apply for aedc meter online, uba bank customer care, own your own home abuja, aedc abuja online payment, buy phone in abuja, online prepaid electricity, electricity bill payment by online, ibuypower app, buypower online, g power meter, how to apply to sell prepaid electricity, npower help, electrical purchasing agent salary, aedc official website, to pay electricity bill, how do i find my prepaid meter number, how to activate uba card for online transaction, prepaid electricity cost per unit, download fcmb mobile app, online buying and selling sites in nigeria, prepaid electricity meter in nigeria, where to buy electricity, nigeria online, paylightbill, how long does it take to sell a wow token, aedc prepaid meter online recharge, gt power app, recharge electricity bill, prepaid meter recharge in up, phed prepaid meter, internet banking gtbank, zenith bank customer careline, how to apply for prepaid meter in lagos, power holding company of nigeria prepaid meter, how to get prepaid meter from ikeja electric, gtbank internet banking app, uba mobile banking app nigeria, how to recharge jed prepaid meter, electricity bill units, adec technologies, buy power card phone number, electricity recharge online, fcmb mobile app, aedc abuja head office address, paypower customer service, online paying electricity bill, gtbank app, zenith bank app download,  adec tech support, electricals bill, jos electricity distribution company online payment, jedco, pay electricity bill, buying load online, buy power card payment, naija app, aedec, how much is gtb token, www uba online, gtb bank internet banking, electric online top up, power holding company of nigeria website' },
      { name: 'author', content: 'irecharge.com.ng' }
    ]
  },
  components: {
    Header, 
    MyNav,
    SideNav,
    SlideOut,
    AdsSlider,
    MobileNav,
    FooterSection
  },
  mounted() {
    this.openMobileMenu()
    let refresh = localStorage.getItem('refresh') 
    if(!refresh && refresh !== "isb32uf02680g8o0w484oo0kg4ow874") {
      sessionStorage.clear()
      localStorage.clear()
      localStorage.setItem('refresh', "isb32uf02680g8o0w484oo0kg4ow874")
      location.reload()
    }
    // this.$router.push({
    //   name: "Adept"
    // })
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
    if(localStorage.getItem('userType') == 2 && localStorage.getItem('status') == null) {
      this.clearSession()
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  data() {
    return {
      modalOption: '',
      window: {
        width: 0,
        height: 0
      },
      currentYear: '',
      sidenavInstance: ''
    }
  },
  methods: {
    selectedView(option) {
      this.modalOption = option
    },
    clearSession() {
      localStorage.setItem("userType", 2)
      localStorage.setItem("status", 1)
      // localStorage.removeItem("attempts")
      // sessionStorage.removeItem("status")
      // localStorage.removeItem('tv')
      // localStorage.removeItem('power')
      // localStorage.removeItem('data')
      // localStorage.removeItem('airtime')
      // localStorage.removeItem('expire')
      // localStorage.removeItem('timestamp')
      // localStorage.removeItem('user')
      // localStorage.removeItem('email')
      // localStorage.removeItem('username')
      window.location.assign('/')
    },
    setLastTransaction(transactions) {
      localStorage.setItem('power', JSON.stringify(transactions[0]))
      localStorage.setItem('tv', JSON.stringify(transactions[1]))
      localStorage.setItem('airtime', JSON.stringify(transactions[2]))
      localStorage.setItem('data', JSON.stringify(transactions[3]))
    },
    handleResize() {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
    },
    openMobileMenu() {
      var elems = document.querySelectorAll('.sidenav')
      var instances = M.Sidenav.init(elems)
      this.sidenavInstance = instances
    },
    whatsApp() {
      window.open('https://api.whatsapp.com/send?phone=09030009930&text=How%20may%20we%20help%20you%20today%20', '_blank');
    }
  }
}
</script>
<style>
@font-face {
  font-family: iRecharge;
  src: url('/ui/font/custom.ttf');
}
#app {
  font-family: 'iRecharge', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.success {
  background-color: #21b266;
}
.error {
  background-color: #e51313c2;
}
.info {
  background-color: #689ae3;
}
.text-justify {
  text-align: justify;
}
.text-center {
  text-align: center;
}
.text-left {
  text-align: left;
}
.text-right {
  text-align: right;
}
td, th {
  padding: 8px 10px;
}
.feedbackForm {
  margin-bottom: 50px;
}
.btn, .btn-large, .btn-small {
  background-color: #1cab60;
}
.btn:hover, .btn-large:hover, .btn-small:hover {
  background-color: #3e9266;
}
.btn:focus, .btn-large:focus, .btn-small:focus, .btn-floating:focus {
  background-color: #3e9266;
}
.toast {
  font-weight: 600;
}
.modal {
  background-color: #fff;
}
.fa.fa-facebook.feedbackEmoji {
  color: #fff; 
  padding: 4px 4px 0px 13px; 
  background-color: #2d4485; 
  border-radius: 3px;
}
</style>
